import $ from 'jquery';
import _ from 'lodash';

const
	$document = $(document),
	preloaderHtml = `
		<div id="preloader">
			<div class="spin"></div>
		</div>
	`;

const togglePreloaderDomElem = state => {

	if (!$('#preloader').size()) {
		$document
			.find('body')
			.append(preloaderHtml);
	}

	$('#preloader')[state]();

};

const debouncedSetPreloaderState = _.debounce(togglePreloaderDomElem, 50);

const setPreloaderState = state => debouncedSetPreloaderState(state);

export default class Preloader {
	constructor() {
		throw new Error("Preloader class can't be an instance");
	}

	static show() {
		setPreloaderState('show');
	}

	static showImmediately(){
		togglePreloaderDomElem('show');
	}

	static hide() {
		setPreloaderState('hide');
	}
}